(function(){
'use strict';
var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var fine=window.matchMedia('(pointer:fine)').matches;
var ALX_FREE_DC=4000; /* free delivery threshold in Rs */

function isDark(){
  return document.body.classList.contains('template-index')||document.documentElement.classList.contains('alx-dark');
}

function initGlobal(){
  if(window.__alxGlobal)return;
  if(!isDark())return;
  window.__alxGlobal=true;
  var bg=document.createElement('div');bg.className='alx-aurora';
  bg.innerHTML='<div class="alx-aur alx-aur1"></div><div class="alx-aur alx-aur2"></div><div class="alx-aur alx-aur3"></div><div class="alx-aur alx-aur4"></div>';
  document.body.appendChild(bg);
  var stars=document.createElement('div');stars.className='alx-stars';
  if(!reduced){for(var i=0;i<44;i++){var s=document.createElement('span');s.className='alx-star';var sz=(Math.random()*2+.6).toFixed(1);s.style.width=s.style.height=sz+'px';s.style.left=Math.random()*100+'vw';s.style.top=Math.random()*100+'vh';s.style.animationDuration=(2+Math.random()*4)+'s';s.style.animationDelay=(-Math.random()*5)+'s';stars.appendChild(s);}}
  document.body.appendChild(stars);
  var grain=document.createElement('div');grain.className='alx-grain';document.body.appendChild(grain);
  var prog=document.createElement('div');prog.className='alx-progress';document.body.appendChild(prog);
  window.addEventListener('scroll',function(){var h=document.documentElement;prog.style.width=(window.scrollY/(h.scrollHeight-window.innerHeight)*100)+'%';},{passive:true});
  if(fine&&!reduced){
    var cur=document.createElement('div');cur.className='alx-cursor';document.body.appendChild(cur);
    var tx=innerWidth/2,ty=innerHeight/2,x=tx,y=ty;
    window.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;},{passive:true});
    (function loop(){x+=(tx-x)*.09;y+=(ty-y)*.09;cur.style.left=x+'px';cur.style.top=y+'px';requestAnimationFrame(loop);})();
  }
}

var io=null;
function initReveal(root){
  if(!io){io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('alx-visible');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -50px'});}
  var els=(root||document).querySelectorAll('.alx-reveal:not([data-alx-obs])');
  els.forEach(function(el,i){el.setAttribute('data-alx-obs','1');el.style.transitionDelay=(i%4)*80+'ms';io.observe(el);});
}

function initTilt(root){
  if(!fine||reduced)return;
  (root||document).querySelectorAll('[data-tilt]:not([data-alx-tilt])').forEach(function(el){
    el.setAttribute('data-alx-tilt','1');var raf=null;
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect();
      var rx=((e.clientY-r.top)/r.height-.5)*-7,ry=((e.clientX-r.left)/r.width-.5)*7;
      if(raf)cancelAnimationFrame(raf);
      raf=requestAnimationFrame(function(){el.style.transform='perspective(900px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-6px)';});
    });
    el.addEventListener('mouseleave',function(){if(raf)cancelAnimationFrame(raf);el.style.transform='';});
  });
}

function initSlideshows(root){
  (root||document).querySelectorAll('.alx-slideshow:not([data-alx-ss])').forEach(function(wrap){
    wrap.setAttribute('data-alx-ss','1');
    var slides=Array.prototype.slice.call(wrap.querySelectorAll('.alx-slide'));
    if(slides.length<1)return;
    var dotsBox=wrap.querySelector('.alx-sdots'),cur=0,timer=null;
    var speed=parseInt(wrap.getAttribute('data-speed')||'5',10)*1000;
    var dots=[];
    if(dotsBox){dotsBox.innerHTML='';slides.forEach(function(_,i){var d=document.createElement('button');d.className='alx-sdot'+(i===0?' alx-active':'');d.type='button';d.setAttribute('aria-label','Slide '+(i+1));d.addEventListener('click',function(e){e.preventDefault();go(i);restart();});dotsBox.appendChild(d);dots.push(d);});}
    function go(i){cur=(i+slides.length)%slides.length;slides.forEach(function(s,j){s.classList.toggle('alx-active',j===cur);});dots.forEach(function(d,j){d.classList.toggle('alx-active',j===cur);});}
    function restart(){clearInterval(timer);if(!reduced&&slides.length>1)timer=setInterval(function(){go(cur+1);},speed);}
    var prev=wrap.querySelector('.alx-snav.alx-prev'),next=wrap.querySelector('.alx-snav.alx-next');
    if(slides.length<2){if(prev)prev.style.display='none';if(next)next.style.display='none';if(dotsBox)dotsBox.style.display='none';}
    if(prev)prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(cur-1);restart();});
    if(next)next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(cur+1);restart();});
    wrap.addEventListener('mouseenter',function(){clearInterval(timer);});
    wrap.addEventListener('mouseleave',restart);
    var sx=0;
    wrap.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    wrap.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>50){go(cur+(dx<0?1:-1));restart();}},{passive:true});
    restart();
  });
}

var cio=null;
function initCounters(root){
  if(!cio){cio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;cio.unobserve(e.target);
    var el=e.target,target=parseFloat(el.getAttribute('data-target')),dec=parseInt(el.getAttribute('data-decimal')||'0',10),suf=el.getAttribute('data-suffix')||'';
    if(isNaN(target))return;
    var t0=performance.now(),dur=2000;
    (function tick(t){
      var p=Math.min((t-t0)/dur,1),ease=1-Math.pow(1-p,4);
      var v=(target*ease).toFixed(dec);
      el.textContent=(+v).toLocaleString(undefined,{minimumFractionDigits:dec,maximumFractionDigits:dec})+(p===1?suf:'');
      if(p<1)requestAnimationFrame(tick);
    })(t0);
  });},{threshold:.5});}
  (root||document).querySelectorAll('.alx-count-up:not([data-alx-c])').forEach(function(el){el.setAttribute('data-alx-c','1');cio.observe(el);});
}

/* reels: video tiles are handled by aurora-reelsfix.js (tap-to-play). Here we only skip them. */
function initReels(root){
  (root||document).querySelectorAll('.alx-reel:not([data-alx-r])').forEach(function(r){
    r.setAttribute('data-alx-r','1');
  });
}

function titleCase(s){return s.toLowerCase().replace(/(^|\s|-|&\s)([a-zà-ÿ])/g,function(m){return m.toUpperCase();});}

function tidyMoneyText(p){
  var t=p.textContent;
  var nt=t.replace(/\.00(?=\D|$)/g,'').replace(/\s*PKR/g,'');
  if(nt!==t)p.textContent=nt.replace(/[ \t]+/g,' ');
}

function cleanDawnCards(){
  if(!document.documentElement.classList.contains('alx-dark'))return;
  document.querySelectorAll('.card__heading a:not([data-alx-t])').forEach(function(a){
    a.setAttribute('data-alx-t','1');
    var t=a.textContent.trim();
    if(t&&t===t.toUpperCase()){a.textContent=titleCase(t);}
  });
  document.querySelectorAll('.price-item:not([data-alx-p])').forEach(function(p){
    p.setAttribute('data-alx-p','1');tidyMoneyText(p);
  });
  document.querySelectorAll('.quick-add__submit:not([data-alx-b])').forEach(function(b){
    b.setAttribute('data-alx-b','1');
    var sp=b.querySelector('span')||b;
    if(!/choose\s*options/i.test(sp.textContent))return;
    var url=b.getAttribute('data-product-url');
    if(!url){
      var cw=b.closest('.card-wrapper')||b.closest('li')||b.closest('.grid__item');
      var ha=cw?cw.querySelector('.card__heading a'):null;
      url=ha?ha.getAttribute('href'):null;
    }
    var a=document.createElement('a');
    a.className=b.className;
    a.setAttribute('data-alx-b','1');
    a.setAttribute('href',url||'#');
    a.style.display='flex';a.style.alignItems='center';a.style.justifyContent='center';a.style.textDecoration='none';
    a.textContent='Buy Now';
    b.parentNode.replaceChild(a,b);
  });
}

function cleanCartText(){
  document.querySelectorAll('cart-drawer .price:not([data-alx-p]), .cart-item .price:not([data-alx-p]), .cart-item__details .price:not([data-alx-p]), .cart-item .product-option:not([data-alx-p]), cart-drawer .product-option:not([data-alx-p]), #cart-notification .product-option:not([data-alx-p]), .totals__total-value:not([data-alx-p]), .totals__subtotal-value:not([data-alx-p]), cart-drawer .totals__total-value:not([data-alx-p])').forEach(function(p){
    p.setAttribute('data-alx-p','1');tidyMoneyText(p);
  });
  document.querySelectorAll('cart-drawer .cart-item__name:not([data-alx-t]), .cart-item__name:not([data-alx-t]), #cart-notification .cart-notification-product__name:not([data-alx-t])').forEach(function(a){
    a.setAttribute('data-alx-t','1');
    var t=a.textContent.trim();
    if(t&&t===t.toUpperCase()){a.textContent=titleCase(t);}
  });
  updateDcBars();
}

var dcLast=0;
function updateDcBars(){
  var targets=[];
  var a=document.querySelector('cart-drawer .drawer__footer');if(a)targets.push(a);
  var b=document.querySelector('.cart__blocks');if(b)targets.push(b);
  var c=document.querySelector('#cart-notification .cart-notification__links');if(c)targets.push(c);
  if(!targets.length)return;
  var now=Date.now();if(now-dcLast<1200)return;dcLast=now;
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var total=(cart.total_price||0)/100;
    targets.forEach(function(t){
      var bar=t.querySelector('.alx-dc');
      if(!bar){bar=document.createElement('div');bar.className='alx-dc';bar.innerHTML='<div class="alx-dc-txt"></div><div class="alx-dc-track"><span></span></div>';t.insertBefore(bar,t.firstChild);}
      var txt=bar.querySelector('.alx-dc-txt'),fill=bar.querySelector('.alx-dc-track span');
      if(total<=0){bar.style.display='none';return;}
      bar.style.display='';
      if(total>=ALX_FREE_DC){txt.innerHTML='🎉 <b>FREE Delivery unlocked!</b>';fill.style.width='100%';}
      else{var rem=ALX_FREE_DC-total;txt.innerHTML='🚚 Add <b>Rs.'+rem.toLocaleString()+'</b> more for <b>FREE Delivery</b>';fill.style.width=Math.max(6,Math.min(100,total/ALX_FREE_DC*100))+'%';}
    });
  }).catch(function(){});
}

function escHtml(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function enhanceCartNotification(){
  var box=document.querySelector('#cart-notification .cart-notification-product');
  if(!box||box.querySelector('.alx-cn-info'))return;
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    if(!cart.items||!cart.items.length)return;
    if(box.querySelector('.alx-cn-info'))return;
    var it=cart.items[0];
    var rows='';
    (it.options_with_values||[]).forEach(function(o){
      if(o&&o.value&&o.value!=='Default Title')rows+='<div class="alx-cn-row"><b>'+escHtml(titleCase(o.name))+':</b> '+escHtml(o.value)+'</div>';
    });
    var props=it.properties||{};
    Object.keys(props).forEach(function(k){
      var v=props[k];
      if(v&&k.charAt(0)!=='_')rows+='<div class="alx-cn-row"><b>'+escHtml(k)+':</b> '+escHtml(v)+'</div>';
    });
    rows+='<div class="alx-cn-row"><b>Quantity:</b> '+it.quantity+'</div>';
    var price='Rs.'+Math.round((it.final_line_price||it.line_price||0)/100).toLocaleString();
    var d=document.createElement('div');d.className='alx-cn-info';
    d.innerHTML=rows+'<div class="alx-cn-price">'+price+'</div>';
    box.appendChild(d);
  }).catch(function(){});
}

function injectCartBoost(target){
  if(!target||target.querySelector('.alx-cart-gift'))return;
  var t=document.createElement('div');t.className='alx-cart-trust';
  t.innerHTML='<span>🚚 3–7 Days Delivery</span><span>💰 Cash on Delivery</span><span>⭐ 4.9 · 1 Lakh+ Customers</span>';
  target.insertBefore(t,target.firstChild);
  var d=document.createElement('div');d.className='alx-cart-gift';
  d.innerHTML='🎁 <b>FREE Travel Kit + Solution Kit</b> included with every lens order';
  target.insertBefore(d,target.firstChild);
}
function initCartExtras(){
  var df=document.querySelector('cart-drawer .drawer__footer');
  if(df)injectCartBoost(df);
  if(document.documentElement.classList.contains('alx-dark')){
    var cf=document.querySelector('.cart__blocks')||document.querySelector('.cart__footer .cart__ctas');
    if(cf)injectCartBoost(cf);
  }
  cleanCartText();
  enhanceCartNotification();
  var cd=document.querySelector('cart-drawer');
  if(cd&&!cd.hasAttribute('data-alx-w')){
    cd.setAttribute('data-alx-w','1');
    new MutationObserver(function(){
      var f=cd.querySelector('.drawer__footer');
      if(f)injectCartBoost(f);
      cleanCartText();
    }).observe(cd,{childList:true,subtree:true});
  }
  var cn=document.querySelector('cart-notification');
  if(cn&&!cn.hasAttribute('data-alx-w')){
    cn.setAttribute('data-alx-w','1');
    new MutationObserver(function(){dcLast=0;cleanCartText();enhanceCartNotification();}).observe(cn,{childList:true,subtree:true});
  }
  var ci=document.getElementById('main-cart-items')||document.querySelector('.cart__contents');
  if(ci&&!ci.hasAttribute('data-alx-w')){
    ci.setAttribute('data-alx-w','1');
    new MutationObserver(function(){dcLast=0;cleanCartText();}).observe(ci,{childList:true,subtree:true});
  }
}

function ensureSaveChip(){
  var info=document.querySelector('.product__info-wrapper');
  if(!info)return;
  if(info.querySelector('.alx-save'))return;
  try{
    var sale=info.querySelector('.price__sale .price-item--sale, .price-item--sale');
    var reg=info.querySelector('.price__sale s.price-item--regular, .price s .price-item--regular, .price s');
    if(sale&&reg){
      var pn=parseFloat(sale.textContent.replace(/[^0-9.]/g,'')),po=parseFloat(reg.textContent.replace(/[^0-9.]/g,''));
      if(po>pn&&pn>0){
        var pct=Math.round((1-pn/po)*100);
        if(pct>=5){var chip=document.createElement('span');chip.className='alx-save';chip.textContent='SAVE '+pct+'%';
        var pr=info.querySelector('.price');if(pr)pr.appendChild(chip);}
      }
    }
  }catch(e){}
}

function eyeStateFor(scope){
  try{
    var txt='';
    scope.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(function(r){txt+=' '+(r.value||'');});
    scope.querySelectorAll('.product-form__input select').forEach(function(s){txt+=' '+(s.value||'');});
    txt=txt.toLowerCase();
    if(txt.indexOf('without eyesight')>-1)return false;
    if(txt.indexOf('with eyesight')>-1)return true;
    var any='';
    scope.querySelectorAll('.product-form__input input[type="radio"]').forEach(function(r){any+=' '+(r.value||'');});
    any=any.toLowerCase();
    if(any.indexOf('eyesight')===-1){
      var hasCus=scope.querySelector('.optionsCus')||document.querySelector('.optionsCus')||document.querySelector('select.option1');
      var h=scope.querySelector('h1')||scope.querySelector('.product__title')||document.querySelector('.product__info-wrapper h1');
      if(hasCus&&h&&/eyesight/i.test(h.textContent))return true;
    }
    return false;
  }catch(e){return false;}
}
function powersOk(scope){
  var o1=scope.querySelector('select.option1')||document.querySelector('select.option1');
  var o2=scope.querySelector('select.option2')||document.querySelector('select.option2');
  if(!o1||!o2)return false;
  return (o1.value||'')!==''&&(o2.value||'')!=='';
}
function clearEyeError(){
  var e=document.querySelector('.alx-eye-err');
  if(e)e.remove();
}
function showEyeError(){
  var btns=document.querySelector('.product__info-wrapper .product-form__buttons');
  if(!btns)return;
  var errEl=document.querySelector('.alx-eye-err');
  if(!errEl){errEl=document.createElement('div');errEl.className='alx-eye-err';btns.parentNode.insertBefore(errEl,btns);}
  else{errEl.style.animation='none';void errEl.offsetWidth;errEl.style.animation='';}
  errEl.textContent='⚠ Please select your eyesight numbers (Left & Right)';
}

function applyVariantUI(){
  if(!document.documentElement.classList.contains('alx-dark'))return;
  var info=document.querySelector('.product__info-wrapper');
  if(!info)return;
  try{
    var eye=eyeStateFor(info);
    document.querySelectorAll('.optionsCus').forEach(function(el){el.style.setProperty('display',eye?'block':'none','important');});
    var idx=0;
    var g=info.querySelector('.product-form__input');
    if(g){var radios=g.querySelectorAll('input[type="radio"]');radios.forEach(function(r,j){if(r.checked)idx=j;});}
    var p2=document.querySelectorAll('.packet2'),p3=document.querySelectorAll('.packet3');
    if(p2.length){p2.forEach(function(el){el.style.display=idx>=1?'block':'none';});document.querySelectorAll('.inputpacket2').forEach(function(i2){i2.setAttribute('name',idx>=1?'properties[2nd Color]':'');});}
    if(p3.length){p3.forEach(function(el){el.style.display=idx>=2?'block':'none';});document.querySelectorAll('.inputpacket3').forEach(function(i3){i3.setAttribute('name',idx>=2?'properties[3rd Color]':'');});}
    var btns=info.querySelector('.product-form__buttons');
    if(btns)btns.style.display='block';
    if(!eye||powersOk(info))clearEyeError();
  }catch(e){}
}

document.addEventListener('submit',function(e){
  try{
    var f=e.target;
    if(!f||!f.getAttribute)return;
    var act=(f.getAttribute('action')||'');
    if(act.indexOf('/cart/add')===-1)return;
    var scope=f.closest('.quick-add-modal__content')||f.closest('quick-add-modal')||f.closest('.product')||document.querySelector('.product__info-wrapper')||document;
    if(!eyeStateFor(scope))return;
    var o1=scope.querySelector('select.option1')||document.querySelector('select.option1');
    var visibleOnPage=o1&&o1.offsetParent!==null;
    if(visibleOnPage&&powersOk(scope)){clearEyeError();return;}
    e.preventDefault();e.stopPropagation();
    var inModal=!!(f.closest('quick-add-modal')||f.closest('.quick-add-modal__content'));
    if(inModal||!o1){
      var link=scope.querySelector('a[href*="/products/"]');
      var idInp=f.querySelector('[name="id"]');
      var url=link?link.getAttribute('href'):null;
      if(url){
        if(idInp&&idInp.value)url+=(url.indexOf('?')>-1?'&':'?')+'variant='+idInp.value;
        window.location.href=url;return;
      }
    }
    document.querySelectorAll('.optionsCus').forEach(function(el){el.style.setProperty('display','block','important');});
    showEyeError();
    var tgt=(o1&&o1.offsetParent!==null)?o1:document.querySelector('.optionsCus');
    if(tgt){
      tgt.scrollIntoView({behavior:'smooth',block:'center'});
      [document.querySelector('select.option1'),document.querySelector('select.option2')].forEach(function(s){
        if(s&&(s.value||'')===''){s.style.boxShadow='0 0 0 2px #e879f9';setTimeout(function(){s.style.boxShadow='';},2600);}
      });
    }
  }catch(err){}
},true);

function initProductExtras(){
  if(window.__alxProd)return;
  if(!document.documentElement.classList.contains('alx-dark'))return;
  var info=document.querySelector('.product__info-wrapper');
  if(!info)return;
  window.__alxProd=true;
  try{
    var h1=info.querySelector('h1');
    if(h1){var t=h1.textContent.trim();if(t&&t===t.toUpperCase())h1.textContent=titleCase(t);}
  }catch(e){}
  ensureSaveChip();
  try{
    var anchor=info.querySelector('.product-form__buttons');
    if(!anchor){var f0=info.querySelector('form[action*="/cart/add"]');if(f0)anchor=f0;}
    if(anchor){
      var pname=(info.querySelector('h1')||{textContent:document.title}).textContent.trim();
      var waMsg=encodeURIComponent('Hi LensesPK! I want to order: '+pname+' \n'+location.origin+location.pathname);
      var box=document.createElement('div');box.className='alx-pboost';
      box.innerHTML='<div class="alx-gift">🎁 <b>FREE Travel Kit + Solution Kit</b> included with this order</div>'
        +'<a class="alx-wa-order" target="_blank" rel="noopener" href="https://wa.me/923394282828?text='+waMsg+'"><svg viewBox="0 0 32 32"><path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.6.8 5 2.3 7L4.5 28l6.3-1.7c1.9 1 4 1.6 6.2 1.6 6.6 0 12-5.3 12-11.9S22.6 3 16 3zm6.1 16.9c-.3.8-1.5 1.5-2.4 1.7-.6.1-1.4.2-4.1-.9-3.5-1.4-5.7-4.9-5.9-5.2-.2-.2-1.4-1.9-1.4-3.6s.9-2.5 1.2-2.9c.3-.3.7-.4 1-.4h.7c.2 0 .5-.1.8.6l1.1 2.7c.1.2.2.4 0 .7l-.4.7-.6.6c-.2.2-.4.4-.2.8.2.3 1 1.6 2.1 2.6 1.5 1.3 2.7 1.7 3 1.9.4.2.6.1.8-.1l1.2-1.4c.3-.4.5-.3.9-.2l2.5 1.2c.4.2.6.3.7.5.1.1.1.7-.2 1.5z"/></svg>Order on WhatsApp</a>'
        +'<div class="alx-ptrust"><span>✔ FDA & CE Approved</span><span>🚚 3–7 Days Delivery</span><span>💰 Cash on Delivery</span><span>⭐ 4.9 · 1 Lakh+ Customers</span></div>';
      anchor.parentNode.insertBefore(box,anchor.nextSibling);
    }
  }catch(e){}
  try{
    var atc=document.querySelector('.product-form__submit');
    if(atc){
      var bar=document.createElement('div');bar.className='alx-sticky';
      bar.innerHTML='<div class="alx-sticky-info"><div class="alx-sticky-t"></div><div class="alx-sticky-p"></div></div><button type="button" class="alx-sticky-btn">Add to Cart</button>';
      bar.querySelector('.alx-sticky-t').textContent=(info.querySelector('h1')||{textContent:''}).textContent.trim();
      var pe=info.querySelector('.price-item--sale')||info.querySelector('.price-item--regular');
      bar.querySelector('.alx-sticky-p').textContent=pe?pe.textContent.replace(/\s+/g,' ').trim():'';
      bar.querySelector('.alx-sticky-btn').addEventListener('click',function(){
        if(atc.disabled||atc.offsetParent===null){atc.scrollIntoView({behavior:'smooth',block:'center'});return;}
        atc.click();
      });
      document.body.appendChild(bar);
      var iov=new IntersectionObserver(function(es){es.forEach(function(e){
        bar.classList.toggle('alx-on',!e.isIntersecting&&e.boundingClientRect.top<0);
      });},{threshold:0});
      iov.observe(atc);
    }
  }catch(e){}
  applyVariantUI();
  document.addEventListener('change',function(e){
    if(!e.target)return;
    if(e.target.matches('.product-form__input input[type="radio"], .product-form__input select, select.option1, select.option2')||e.target.closest('.product-form__input')){
      setTimeout(applyVariantUI,80);
      setTimeout(applyVariantUI,400);
    }
  },true);
  try{
    var mo=new MutationObserver(function(){
      clearTimeout(mo.__t);
      mo.__t=setTimeout(function(){cleanDawnCards();ensureSaveChip();applyVariantUI();
        var pe2=info.querySelector('.price-item--sale')||info.querySelector('.price-item--regular');
        var sp=document.querySelector('.alx-sticky-p');
        if(pe2&&sp)sp.textContent=pe2.textContent.replace(/\s+/g,' ').trim();
      },120);
    });
    mo.observe(info,{childList:true,subtree:true});
  }catch(e){}
}

function initAll(root){initGlobal();cleanDawnCards();initProductExtras();initCartExtras();initReveal(root);initTilt(root);initSlideshows(root);initCounters(root);initReels(root);}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll();});}else{initAll();}
document.addEventListener('shopify:section:load',function(e){initAll(e.target);});

var pgc=null;
function watchGrid(){
  var target=document.getElementById('ProductGridContainer');
  if(!target||pgc)return;
  pgc=new MutationObserver(function(){cleanDawnCards();});
  pgc.observe(target,{childList:true,subtree:true});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watchGrid);}else{watchGrid();}
})();
